/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const UPDATE_DISPLAY = gql`
  mutation UpdateDisplay($data: DisplayInput!) {
    updateDisplay(data: $data) {
      id
      name
      averageDepth
      store {
        id
      }
    }
  }
`
